import React, { useEffect, useState } from "react";
import { BiSolidCategory } from "react-icons/bi";
import { FaPlus } from "react-icons/fa";
import { TfiMenuAlt } from "react-icons/tfi";
import Navbar from "../../component/Navbar/Navbar";
import Sidebar from "../../component/sidebar/Sidebar";
import { NavLink } from "react-router-dom";
import useRedirectLogoutUser from "../../CustomHook/useRedirectLogoutUser";
import { useDispatch, useSelector } from "react-redux";
import {
  deleteItem,
  getItems,
  selectitems,
  selectItemSuccess,
} from "../../redux/features/item/ItemSlice";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import { toast } from "react-toastify";
import ReactPaginate from "react-paginate";
import "./Items.css";
import ItemLogo from "../../Asset/item logo.png";
import {
  filterItems,
  selectFilteredItems,
} from "../../redux/features/filter/FilterSlice";
import ItemTable from "./ItemTable";

export const sidebarSections = [
  {
    name: "Items",
    icon: <TfiMenuAlt />,
    path: "/items",
  },
  {
    name: "Categories",
    icon: <BiSolidCategory />,
    path: "/categories",
  },
];

const Items = () => {
  useRedirectLogoutUser("/login");
  const [search, setSearch] = useState("");

  let items = useSelector(selectitems);

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getItems());
  }, [dispatch]);

  // delete item
  const confirmDelete = (id, name) => {
    if (!id || !name) {
      toast.error("ID or Name is undefined");
      return;
    }
    confirmAlert({
      title: "Delete This Item",
      message: `Are you sure to delete this ${name}?`,
      buttons: [
        {
          label: "Delete",
          onClick: () => removeItem(id),
        },
        {
          label: "Cancel",
        },
      ],
    });
  };

  // start pagination
  const fliterItems = useSelector(selectFilteredItems);
  const itemsPerPage = 10;
  const [itemOffset, setItemOffset] = useState(0);
  const endOffset = itemOffset + itemsPerPage;
  const currentItems = fliterItems?.slice(itemOffset, endOffset);
  const pageCount = Math.ceil(fliterItems?.length / itemsPerPage);

  // Invoke when user click to request another page.
  const handlePageClick = (event) => {
    const newOffset = (event.selected * itemsPerPage) % fliterItems?.length;

    setItemOffset(newOffset);
  };
  // end pagination

  const isSuccess = useSelector(selectItemSuccess);

  const removeItem = async (id) => {
    await dispatch(deleteItem(id));
    if (isSuccess) {
      dispatch(getItems());
    }
  };

  useEffect(() => {
    dispatch(filterItems({ search, items }));
  }, [dispatch, search, items]);

  return (
    <div className="flex flex-col h-screen bg-[#F1F1F1]">
      {/* Navbar */}
      <Navbar page="Items" />

      <div className="flex flex-1 overflow-hidden">
        {/* Sidebar */}
        <div className="w-[30%] md:block hidden bg-white shadow-md">
          <Sidebar sidebarSections={sidebarSections} />
        </div>

        {/* Main Content */}
        <div className="flex-1 p-8 relative overflow-y-auto  scrollbar-hide ">
          {/* Product List */}
          {items?.length > 0 ? (
            <>
              <div className="lg:w-full w-[37rem] mx-auto mb-10 ">
                <div className="flex lg:justify-end justify-start my-4 items-center ">
                  <input
                    type="search"
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                    className="bg-transparent py-2 px-4 border-2 border-[#A9A9A9]  rounded-full outline-none"
                    placeholder="Search by name..."
                  />
                </div>
                <div className="space-y-4">
                  <div className="mt-[2rem] w-[100%] overflow-auto scrollbar-hide touch-auto border-none rounded-xl">
                    <table className="w-[100%]   ">
                      <thead className="bg-[#D9D9D9] lg:h-[5rem] h-[4rem]  lg:text-[1rem] text-[.9rem]  ">
                        <tr>
                          <th
                            className="p-3 font-bold tracking-wide text-start "
                            scope="col"
                          >
                            Product Id
                          </th>
                          <th
                            className="p-3 font-bold tracking-wide text-start "
                            scope="col"
                          >
                            Name
                          </th>
                          <th
                            className="p-3 font-bold tracking-wide text-start "
                            scope="col"
                          >
                            Barcode
                          </th>
                          <th
                            className="p-3 font-bold tracking-wide text-start "
                            scope="col"
                          >
                            Quantity
                          </th>
                          <th
                            className="p-3 font-bold tracking-wide text-start  "
                            scope="col"
                          >
                            Cost
                          </th>
                          <th
                            className="p-3 font-bold tracking-wide text-start  "
                            scope="col"
                          >
                            Price
                          </th>
                          <th
                            className="p-3 font-bold tracking-wide text-start  "
                            scope="col"
                          >
                            Action
                          </th>
                        </tr>
                      </thead>
                      <tbody className="bg-white">
                        {currentItems?.map((item, i) => (
                          <ItemTable
                            key={i}
                            id={item._id}
                            productId={item.productId}
                            name={item.name}
                            barcode={item.barcode}
                            cost={item.cost}
                            price={item.price}
                            quantity={item.inventory}
                            confirmDelete={confirmDelete}
                          />
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
                {fliterItems?.length > itemsPerPage && (
                  <ReactPaginate
                    breakLabel="..."
                    nextLabel="Next"
                    onPageChange={handlePageClick}
                    pageRangeDisplayed={2}
                    pageCount={pageCount}
                    previousLabel="Prev"
                    renderOnZeroPageCount={null}
                    containerClassName="pagination"
                    pageLinkClassName="page-num"
                    previousLinkClassName="page-num"
                    nextLinkClassName="page-num"
                    activeLinkClassName="activePage"
                  />
                )}
              </div>

              {/* Add New Item Button */}
              <NavLink
                to={"/createItem"}
                className="fixed bottom-8 right-10 md:w-14 w-10 md:h-14 h-10 bg-[#0D868C] text-white rounded-full shadow-lg flex items-center justify-center hover:bg-teal-600 focus:outline-none focus:ring-2 focus:ring-teal-500 focus:ring-offset-2"
              >
                <FaPlus className="md:text-xl text-[1rem]" />
              </NavLink>
            </>
          ) : (
            <div className="flex items-center justify-center">
              <div className="w-[29rem] lg:w-[38rem]  relative  lg:h-[30rem] h-[23rem] bg-[#A9A9A9] rounded-[2.4rem] text-white flex flex-col justify-center items-center ">
                <img src={ItemLogo} alt="Logo" />

                <p className="text-[1rem] md:text-[1.5rem] font-inter-700 text-center">
                  You have no item yet
                </p>
                <p className="text-[.8rem] md:text-[1rem] font-inter-400 text-center">
                  To add a item, press the (+) button
                </p>
                <NavLink
                  to={"/createItem"}
                  className=" absolute bottom-8 right-8 md:w-14 w-10 md:h-14 h-10 bg-[#0D868C] text-white rounded-full shadow-lg flex items-center justify-center hover:bg-teal-600 focus:outline-none focus:ring-2 focus:ring-teal-500 focus:ring-offset-2"
                >
                  <FaPlus className="md:text-xl text-[1rem]" />
                </NavLink>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Items;
